import { render, staticRenderFns } from "./ExaminationNew.vue?vue&type=template&id=48f99f6e&scoped=true&"
import script from "./ExaminationNew.vue?vue&type=script&lang=js&"
export * from "./ExaminationNew.vue?vue&type=script&lang=js&"
import style0 from "./ExaminationNew.vue?vue&type=style&index=0&id=48f99f6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f99f6e",
  null
  
)

export default component.exports